import styled from "@emotion/styled"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Link from "@mui/material/Link"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { Link as RouterLink, useRouteMatch } from "react-router-dom"
import Chart from "@sb1finans/components/dist/Chart"
import { formatCurrency, FormattedCurrency } from "@sb1finans/components/dist/FormattedCurrency"
import { SvgIcon, SvgIconProps } from "@mui/material"
import LatestOrders from "../components/LatestOrders"
import { useContext, useEffect, useState } from "react"
import { Order } from "@sb1finans/new-api/dist"
import { AccountContext } from "../providers/AccountProvider"
import { OrderContext } from "../providers/OrderProvider"

const Actions = styled.div`
  height: 600px;
  background-color: #fff;
  padding: 48px 0px;
`

const CardContainer = styled.div`
background: #fff;
border: 2px solid transparent;
border-radius: 5px;
box-shadow: 0 1px 4px 0 rgb(38 38 38 / 30%);
cursor: pointer;
display: flex;
flex-flow: row nowrap;
margin: 0 0 8px;
max-width: 440px;
min-height: 80px;
outline: 0;
padding: 24px;
text-decoration: none;
transition: border-color .2s;
width: 80%;
&:hover {
  border-color: #005aa4;
}
`

const IconSvg = () => (
    <svg style={{fill: "#002776", width: "40px"}} viewBox="0 0 200 200" className="ffe-icon-card__icon"><path d="m158.05,5c-5.14439,0-7.84287,6.20104-4.1389,9.59739l1.64854,1.59366-71.5889,64.7381-19.9579-17.7782c-4.52706-3.9957-11.327-3.9957-15.8541,0l-45.4934,40.762c-1.23465,0.99893-1.859,2.58065-1.859,4.17894v3.61231c0,4.99463,5.97685,7.3755,9.68081,4.17893l45.4928-40.9394,19.9579,17.7782c4.52707,3.99569,11.327,3.99569,15.8541,0l73.8688-66.7213,3.29709,3.18732c3.70396,3.59614,9.85619,0.992762,9.85619-4.00186v-14.5904c0-3.19657-2.66573-5.59553-5.75237-5.59553h-15.0123zm-13.7846,66.1193c-6.37906,0-11.7503,5.01041-11.7503,11.4035v98.7009h-9.26v-57.3364c0-6.19333-5.13037-11.4035-11.7152-11.4035h-22.6589c-6.37904,0-11.7152,5.01041-11.7152,11.4035v57.3364h-9.25991v-24.7903c0-6.19335-5.13037-11.3681-11.7152-11.3681h-22.6587c-6.37905,0-11.7152,4.97499-11.7152,11.3681v24.7903h-16.0645c-3.29241,0-5.75237,2.598-5.75237,5.595v2.58526c0,3.197,2.66573,5.596,5.75237,5.596h188.495c3.29237,0,5.75237-2.599,5.75237-5.596v-2.58526c0-3.19657-2.66573-5.59553-5.75237-5.59553h-15.644v-98.7002c0-6.19334-5.13037-11.4035-11.7152-11.4035h-22.6236zm2.66573,13.9888,17.0817,0,0,96.1156-17.0817,0,0-96.1156zm-54.9632,41.5769,17.0817,0,0,54.5387-17.0817,0,0-54.5387zm-55.1385,32.369,17.0817,0,0,22.1696-17.0817,0,0-22.1696z"></path></svg>
)


interface CardProps {
    title: string
}

const Card: React.FC<CardProps> = ({title}) => (
  <CardContainer>
    <Stack direction="row" spacing={2} justifyContent="left">
      <IconSvg />
      <Typography style={{display: "flex", alignItems: "center"}} variant="h5">{title}</Typography>
    </Stack>
  </CardContainer>
)

const Footer = () => {
    return <div></div>
}

interface ChartLabelProps {
    strokecolor: string
}
const ChartLabel = styled(Typography)<ChartLabelProps>`
  &:before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 12px;
    background: ${props =>  props.strokecolor};
    margin-right: 8px;
    border-radius: 4px;
  }
`;

interface HomePageProps {
  agreementId: string
}

export const HomePage: React.FC<HomePageProps> = ({agreementId}) => {

  console.log("agreementId", agreementId)

  const {accounts} = useContext(AccountContext)
  const {orders} = useContext(OrderContext)

  const account = accounts && accounts[0]

  const availableBalance = accounts
    .map(account => parseInt(account.availableBalance))
    .reduce((prev, curr) => prev + curr, 0)

  const creditLimit = accounts
    .map(account => parseInt(account.creditLimit))
    .reduce((prev, curr) => prev + curr, 0)

  const bookedBalance = accounts
    .filter(account => account.accountNumber.startsWith("FK_kjop"))
    .map(account => parseInt(account.bookedBalance))
    .reduce((prev, curr) => prev + curr, 0)

  
  const amount = 0//invoices ? invoices.reduce((acc, invoice) => acc + parseFloat(invoice.totalAmount), 0) : 0

  const {url} = useRouteMatch()

  /*useEffect(() => {
    const currentDate = new Date()
    const fromDate = new Date(currentDate.getFullYear(), 6/*currentDate.getMonth(), 1)
    const toDate = new Date()
    fetchOrders({fromDate, toDate})
    const orders = getOrders({fromDate, toDate}, 1000, 0)
    setOrders(orders)
  }, [])*/

  console.log("IN HOMEPAGE", account)
  return (
    <>
        <Actions>
          <Box sx={{ flexGrow: 1, width: "100%"}}>
          <Grid container rowSpacing={{xs: 0, sm: 8}} justifyContent="center" sx={{margin: "0 auto"}}>
            <Grid item xs={12} sm={4}>
              <Link underline="none" component={RouterLink} to={`${url}/selgfaktura`}>
                <Card title="Selg faktura" />
              </Link>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Link underline="none" component={RouterLink} to={`${url}/behandlingsoversikt`}>
                <Card title="Fakturaoversikt"/>
              </Link>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Box sx={{background: "#F6F6F3", padding: "24px 0"}}>
                <Chart value1={availableBalance} value2={creditLimit} label1={formatCurrency(availableBalance)} label2={`${creditLimit}`}/>
                <Stack sx={{width: "300px", margin: "16px auto"}}>
                  <ChartLabel strokecolor="#005aa4" variant="body1">Kredittgrense: <span><FormattedCurrency>{creditLimit}</FormattedCurrency></span></ChartLabel>
                  <ChartLabel strokecolor="#a5cbe0" variant="body1">Bokført saldo: <span><FormattedCurrency>{bookedBalance}</FormattedCurrency></span></ChartLabel>
                </Stack>
              </Box>
            </Grid>
            {/*<Grid item xs={12} sm={4}>
              <Stack justifyContent="center" alignItems="center" sx={{height: "100%", textAlign: "center", background: "#d8e9f2", padding: "24px"}}>
                <Typography variant="h6" color="#002776">Utbetalt denne måneden</Typography>
                <MoneyIcon sx={{fill: "#002776", height: "80px", width: "80px", margin: "12px"}} style={{height: "200px"}} />
                <Typography variant="h3" color="#002776" fontWeight="400"><FormattedCurrency>{amount}</FormattedCurrency></Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={8}>
              <LatestOrders orders={orders} />
            </Grid>
            <Grid item xs={12} sm={12} style={{flexGrow: 1}}>
            </Grid>
            <Grid item xs={12} sm={12} style={{flexShrink: 0}}>
              <Footer />
            </Grid>
            */}
          </Grid>
          </Box>
        </Actions>
  </>
  )
}


const MoneyIcon: React.FC<SvgIconProps> = ({sx}) => (
    <SvgIcon sx={sx} viewBox="0 0 200 200">
      <path d="M60.28,0c-26.39,0-53.28,9.03-53.28,26.06v33.82,33.81,33.81c0,13.9,18.1,22.5,39.31,25v21.4c0,17.1,26.93,26.1,53.31,26.1s53.28-9,53.28-26.1v-12.6c21.5-2.6,40.1-11.1,40.1-25.3v-33.6-33.74c0-17.04-26.6-26.07-53.3-26.07-9,0-18.1,1.03-26.1,3.1v-19.63c0-17.03-26.93-26.06-53.32-26.06zm0,15.75c23.54,0,37.01,7.21,37.78,10.56-0.77,3.1-14.24,10.6-37.78,10.6s-37.23-7.5-37.75-10.6c0.78-3.35,14.21-10.56,37.75-10.56zm-37.75,29.16c10.09,4.64,24.04,7.21,37.75,7.21s27.69-2.31,37.78-7.21v6.71c-6.46,3.88-10.88,8.78-11.65,14.97-6.47,2.07-15.26,3.6-26.13,3.6-23.54,0-37.23-7.47-37.75-10.57v-14.71zm117.2,13.15c23.6,0,37.3,7.5,37.8,10.6-0.8,3.09-14.2,10.56-37.8,10.56-23.5,0-37.2-7.47-37.8-10.56,0.6-3.1,14.3-10.6,37.8-10.6zm-117.2,20.66c10.09,4.64,24.04,7.22,37.75,7.22,9.06,0,18.11-1.03,26.13-3.1v17.86c-6.47,2-15,3.5-26.13,3.5-23.54,0-37.23-7.42-37.75-10.51v-14.97zm79.37,8.75c10.1,4.64,24.1,7.25,37.8,7.25s27.7-2.35,37.8-7.25v14.93c-0.5,3.1-14.2,10.6-37.8,10.6-23.5,0-37.2-7.5-37.8-10.6v-14.93zm-79.37,25.03c10.09,4.7,24.04,7.3,37.75,7.3,2.07,0,4.15-0.1,6.22-0.3-10.61,3.8-18.1,9.5-19.91,17.5-15-2-23.54-7.2-24.06-9.5v-15zm155,8.5v15c-0.5,2.6-9.1,7.7-24.6,9.8v-5.7c0-4.6-2.1-8.7-5.4-12.1,11.1-0.8,21.7-3.1,30-7zm-77.88,8.8c23.58,0,36.98,7.2,37.78,10.6-0.8,3.1-14.2,10.6-37.78,10.6-23.54-0.3-37.26-7.5-37.78-10.6,0.52-3.1,14.24-10.6,37.78-10.6zm-37.78,29.2c10.09,4.6,24.07,7.2,37.78,7.2,13.68,0,27.68-2.3,37.78-7.2v14.9c-0.5,3.1-14.2,10.6-37.78,10.6-23.54,0-37.26-7.5-37.78-10.6v-14.9z"></path>
    </SvgIcon>
  )